import "./Input.scss";

export default function DateInputMobile({
  label,
  placeholder,
  type,
  value,
  onChange,
}) {
  return (
    <div style={{ position: "relative" }}>
      <div className="label">{label}</div>
      <input
        placeholder={placeholder}
        type={type}
        value={value}
        onChange={onChange}
      />
      {!value && <div className="placeholder">{placeholder}</div>}
    </div>
  );
}
